import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import { useGlobalContent } from '../../../hooks';
import './OrderBreakdown.scss';

const OrderBreakdown = ({ title, breakdown }) => {
  const { priceBreakdown } = useGlobalContent('orders');

  return (
    <div className="order-breakdown">
      <h5 className="text-kilo bold order_breakdown__title">{title}</h5>
      {map(breakdown, ({ formatted }, key) => {
        const { label = `Missing translation for "${key}"` } = priceBreakdown.find(item =>
          item.type === key
        ) || {};

        return (
          <div key={key} className="order-breakdown__row">
            <p className="text-kilo order-breakdown__item__label">{label}</p>
            <p className="text-kilo order-breakdown__item__price">{formatted}</p>
          </div>
        );
      })}
    </div>
  );
};

OrderBreakdown.propTypes = {
  title: PropTypes.string.isRequired,
  breakdown: PropTypes.object.isRequired,
};

export default OrderBreakdown;



// WEBPACK FOOTER //
// ./src/client/js/view/components/OrderDetails/OrderBreakdown/OrderBreakdown.js